import React from "react";
import { useNavigate } from "react-router-dom";
import AppShell from "../../components/AppShell";
import { clearMonitorSession, getStoredMonitorSession, monitorLogin, monitorMe } from "../../api/client";
import "./LoginPage.css";

export default function LoginPage() {
  const navigate = useNavigate();
  const [username, setUsername] = React.useState("");
  const [password, setPassword] = React.useState("");
  const [error, setError] = React.useState("");
  const [submitting, setSubmitting] = React.useState(false);

  React.useEffect(() => {
    let mounted = true;

    if (!getStoredMonitorSession()) {
      return () => {
        mounted = false;
      };
    }

    monitorMe()
      .then(() => {
        if (!mounted) return;
        navigate("/main", { replace: true });
      })
      .catch(() => {
        if (!mounted) return;
        clearMonitorSession();
      });

    return () => {
      mounted = false;
    };
  }, [navigate]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError("");
    setSubmitting(true);
    try {
      await monitorLogin(username, password);
      navigate("/main", { replace: true });
    } catch (loginError) {
      setError(loginError.message || "로그인에 실패했습니다.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <AppShell
      title="로그인"
    >
      <section className="login-panel">
        <form className="login-form" onSubmit={handleSubmit}>
          <label>
            <span>아이디</span>
            <input value={username} onChange={(event) => setUsername(event.target.value)} autoComplete="username" />
          </label>
          <label>
            <span>비밀번호</span>
            <input
              type="password"
              value={password}
              onChange={(event) => setPassword(event.target.value)}
              autoComplete="current-password"
            />
          </label>
          {error ? <div className="login-error">{error}</div> : null}
          <button type="submit" disabled={submitting}>
            {submitting ? "로그인 중..." : "로그인"}
          </button>
        </form>
      </section>
    </AppShell>
  );
}
